import { mergeAttributes, Node, nodeInputRule } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ImageWithTool from './ImageWithTool.vue';
export var inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;
export var ImageWithTools = Node.create({
    name: 'image',
    draggable: true,
    addOptions: function () {
        return {
            inline: false,
            allowBase64: false,
            HTMLAttributes: {},
            resize: true,
            resizeIcon: null,
            onExtraCreated: function () { },
            onError: function () { }
        };
    },
    inline: function () {
        return this.options.inline;
    },
    group: function () {
        return this.options.inline ? 'inline' : 'block';
    },
    addAttributes: function () {
        return {
            src: {
                default: null
            },
            alt: {
                default: null
            },
            title: {
                default: null
            },
            width: {
                default: 'auto',
                renderHTML: function (attributes) {
                    return {
                        width: attributes.width
                    };
                }
            },
            height: {
                // 原为 'atuo' 拼写错误，未显式设高的图片会渲染出非法的 height="atuo"
                default: 'auto',
                renderHTML: function (attributes) {
                    return {
                        height: attributes.height
                    };
                }
            }
        };
    },
    parseHTML: function () {
        return [
            {
                tag: this.options.allowBase64 ? 'img[src]' : 'img[src]:not([src^="data:"])'
            }
        ];
    },
    renderHTML: function (_a) {
        var HTMLAttributes = _a.HTMLAttributes;
        return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    addCommands: function () {
        var _this = this;
        return {
            // prettier-ignore
            setImage: function (options) { return function (_a) {
                var commands = _a.commands;
                return commands.insertContent([{
                        type: _this.name,
                        attrs: options,
                    }]);
            }; }
        };
    },
    addNodeView: function () {
        return VueNodeViewRenderer(ImageWithTool);
    },
    addInputRules: function () {
        return [
            nodeInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: function (match) {
                    var alt = match[2], src = match[3], title = match[4], width = match[5], height = match[6];
                    return { src: src, alt: alt, title: title, width: width, height: height };
                }
            })
        ];
    }
});
